import Vue from "vue"
import getPageTitle from "@/utils/getPageTitle"
import router from "@/router"

router.afterEach((to) => {
  Vue.nextTick(() => {
    document.title = getPageTitle(to.meta.title)
  })
})
